export default "/kiban/_next/static/images/laserVia-ec2d6547675c918a19a941f569be5493.png";